import { Flex } from "@jsq/ds/core";
import * as styles from "./ConjunctionDivider.css";
import type { ConjunctionOperator } from "./types";

type ConjunctionDividerProps = {
  /** Lower-case conjunction shown inside the leading tag. */
  conjunction: ConjunctionOperator;
};

/**
 * Small leading tag + horizontal line used to separate sibling rule clauses.
 * `or` sits between clauses inside a group; `and` sits between groups.
 *
 * The line is purely decorative — the tag's text already conveys the
 * relationship — so it carries `aria-hidden`. The component itself is a
 * `role="separator"` so assistive tech can announce it as a break between
 * groups of inputs without needing the visual line.
 */
export const ConjunctionDivider = ({ conjunction }: ConjunctionDividerProps) => (
  <Flex
    alignItems="center"
    gap="12px"
    role="separator"
    aria-label={conjunction}
    className={styles.conjunctionDivider}
  >
    <span className={styles.tag}>{conjunction}</span>
    <span className={styles.line} aria-hidden="true" />
  </Flex>
);
